import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getCurrentDateInput } from "../../../generalfunc";
import { getIdData, addData, updateData } from "../../../lib/studentprogresstask";
import { TaskTopic911Select, TaskTopic12Select } from '../../ui/myselect'
import { getStudentClass } from '../../../lib/classdetailview'

export default function GlobalStudentTaskEdit() {
	const { status } = useParams()
	const location = useLocation()
	const queryParams = new URLSearchParams(location.search)
	const studentId = queryParams.get('studentId')
	const type = queryParams.get('type')

	const navigate = useNavigate()

	const isEdit = status?.toLowerCase() !== 'add'

	const [taskTopic, setTaskTopic] = useState('')
	const [assigmentText, setAssigmentText] = useState('')
	const [assignedDate, setAssignedDate] = useState(getCurrentDateInput())
	const [dueDate, setDueDate] = useState(getCurrentDateInput())
	const [studentClass, setStudentClass] = useState()

	if (!studentId || !type) {
		return <div className="alert alert-danger m-4">studentId or type parameter is missing! Please go back and try again.</div>
	}

	useEffect(() => {
		if (isEdit) {
			loadTaskData()
		}
		getStudentClassData()
	}, [status])

	const getStudentClassData = async () => {
		try {
			const classInfo = await getStudentClass(studentId)
			if (classInfo && classInfo.length > 0) {
				setStudentClass(classInfo[0].grade)
			}
		} catch (error) {
			console.error('Failed to fetch student class:', error)
		}
	}

	const loadTaskData = async () => {
		try {
			const data = await getIdData(status)
			const task = data[0]

			if (task) {
				setAssigmentText(task.taskname)
				setAssignedDate(task.taskdate)
				setDueDate(task.taskenddate)
				setTaskTopic(task.subject || '')
			} else {
				console.warn('Task not found.')
			}
		} catch (error) {
			console.error('Failed to load task:', error)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		const payload = {
			studentId,
			taskname: assigmentText,
			taskdate: assignedDate,
			taskenddate: dueDate,
			isFinish: false,
			progresstype: type,
			subject: taskTopic
		}

		try {
			if (isEdit) {
				await updateData(status, payload)
			} else {
				await addData(payload)
			}

			navigate(`/instructor/instructor-studenttask/${studentId}?collapse=open`)
		} catch (error) {
			console.error('Failed to save task:', error)
			alert('An error occurred while saving the task.')
		}
	}

	return (
		<div className="container mt-4">
			<h3>{isEdit ? 'Update Task' : 'Add New Task'}</h3>
			<form onSubmit={handleSubmit}>
				<div className="form-group mb-3">
					<label>Topic</label>
					{studentClass > 11 ? (
						<TaskTopic12Select value={taskTopic} setValue={setTaskTopic} />
					) : (
						<TaskTopic911Select value={taskTopic} setValue={setTaskTopic} />
					)}
				</div>

				<div className="form-group mb-3">
					<label>Task</label>
					<input type="text" className="form-control" value={assigmentText} onChange={(e) => setAssigmentText(e.target.value)} required />
				</div>

				<div className="form-group mb-3">
					<label>Assignment Date</label>
					<input type="date" className="form-control" value={assignedDate} onChange={(e) => setAssignedDate(e.target.value)} />
				</div>

				<div className="form-group mb-3">
					<label>Due Date</label>
					<input type="date" className="form-control" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
				</div>

				<div className="d-flex justify-content-between">
					<button type="submit" className="btn btn-primary">
						{isEdit ? 'Update' : 'Add'}
					</button>
					<button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
						Cancel
					</button>
				</div>
			</form>
		</div>
	)
}
